<community-svg-sprite />

<div class="community-layout content-padding">
    <div class="container">
        <side-menu [totalRooms]="totalRooms"></side-menu>
        <div class="community-layout-wrapper">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-10 col-xl-10 desktop-fixed-width">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>
